import { NavType } from '../types';
export var getSecondaryNavLinks = function getSecondaryNavLinks(_ref) {
  var navType = _ref.navType,
      onClickSignOut = _ref.onClickSignOut;
  var items = [];
  items.push({
    text: 'My account',
    href: 'my/account'
  });

  if (navType === NavType.books) {
    items.push({
      text: 'My orders',
      href: 'my/orders'
    }, {
      text: 'Track books',
      href: 'tracking'
    });
  }

  items.push({
    text: 'Return books',
    href: 'returnbooks'
  }, {
    text: 'Sell books',
    href: 'sell-textbooks'
  }, {
    text: 'Help',
    href: 'contactus'
  }, {
    text: 'Sign out',
    href: 'signout?onlyView=1',
    onClick: onClickSignOut
  });
  return items;
};